import React, { useState } from 'react'
import { shallowEqual, useDispatch, useSelector, } from 'react-redux';
//import { createSelector } from '@reduxjs/toolkit'
import Cookies from 'universal-cookie';
import Layout from '../Layout.js';
import WarningModal from '../components-modals/WarningModal.js';
import { CheckCircleIcon, ExclamationCircleIcon, DocumentCheckIcon } from '@heroicons/react/24/outline';
import Container from '../components-layout/Container.js';
import Header from '../components-layout/Header.js';
import BaseLayout from './containers/BaseLayout.js';
import { getAuth } from '../../app/authSlice.js'



const CentroIndex = () => {
  const cookies = new Cookies();
  const urlSchool = cookies.get('__urlSchoolApi') // url para enviar al api viene de cookies
  const urlInvoice = cookies.get("__urlInvoiceApi"); // url para enviar al api viene de cookies
  const urlCursos = cookies.get("__urlCursosApi"); // url para enviar al api viene de cookies

  console.log('cursos', urlCursos)
  console.log('school',urlSchool)
  console.log('urlSchool: ', urlSchool)
  

  const user = useSelector((state) =>  state.auth.user)
  const IdSede = useSelector((state) => state.auth.IdSede);
  const IdEmp = useSelector((state) =>  state.auth.IdEmp);
  const { headersAPI: headers } = useSelector( (state) =>  state.url);
  let  userObj = JSON.parse(user);
  console.log('headers', headers)

  const [validarUser, setValidarUser] = useState(useSelector(state => state.auth.user))
  //useSelector(state => state?.auth?.user)

  const [respuesta, setRespuesta] = useState("")
  const [loading, setLoading] = useState(false)

  const [pathname, setpathname] = useState(window.location.pathname)

  const dispatch = useDispatch()
  const [contador, setContador] = useState(false)
  

  const urlAdmin = process.env.REACT_APP_URL_API_SEG // Para pruebas
  // const urlAdmin = process.env.REACT_APP_URL_API_PRO_SEG // Para producción 
  //localStorage.removeItem('showAdmisiones')
  if ((validarUser === null || validarUser === undefined || validarUser === '' || validarUser === false) && !contador) {
    localStorage.setItem('showAdmisiones', JSON.stringify(true))
    setContador(true);
    dispatch(getAuth({
      config: {
        method: "POST", //Propiedad method, "POST", "GET", etc
        url: urlAdmin + "/seguridad/login", //URL de la API
        headers: {
          'Authorization': process.env.REACT_APP_TOKEN_API,
          'Content-ID': process.env.REACT_APP_AUDIENCIA_API,
          'Content-Type': 'application/json'
        }, //Propiedad headers, por si la API solicita token, audiencia, etc
        payload: JSON.stringify({ LoginId: 'publico', password: 'c@mpu$V4' }), //Propiedad payload --> datos a enviar en la solicitud http
      },
      rememberUser: false,
    }))
  }

  const [modal, setModal] = useState({
    show: false,
    ok: false,
    msg: "",
  });

  return (
    <>
      <Layout userObj={userObj} activeTab="Asignación de cursos">

        <Container height="h-full">
          <Header title="Cursos" logo={DocumentCheckIcon} />
          <WarningModal
            open={loading ? true : false}
            image={<img src="./img/loader.gif" alt="loading" />}
            opacity="bg-opacity-100"
          />
          <WarningModal
            open={modal.show ? true : false}
            image={
              modal.ok ? (
                <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
              ) : (
                <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
              )
            }
            title="Aviso"
            subtitle={<span>{modal.msg}</span>}
            opacity="bg-opacity-50"
          >
            <div className="mt-5 sm:mt-6">
              <button
                onClick={() => {
                  if (modal.reload) {
                    window.location.reload();
                  }
                  setModal((curr) => ({
                    ...curr,
                    show: false,
                    reload: false,
                  }));
                }}
                type="button"
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >
                Entendido
              </button>
            </div>
          </WarningModal>
          <div className={"shadow-white shadow-sm  rounded-md"}>
            <BaseLayout urlSchool={urlSchool} urlCursos={urlCursos} headers={headers} IdEmp={IdEmp} respuesta={respuesta} setModal={setModal} setLoading={setLoading} pathname={pathname} modal={modal}/>
          </div>
        </Container>
      </Layout>
    </>
  )
}

export default CentroIndex